<div class="card-header">
  <app-breadcrumb currentPage="Statements Debuggen"></app-breadcrumb>
    <div class="menu" [matMenuTriggerFor]="menu">
      <span class="material-icons white">more_vert</span>
    </div>
    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item routerLink="../">
        <mat-icon>arrow_back</mat-icon>
        <span>terug</span>
      </button>
    </mat-menu>
</div>
<div class="card-body" *ngIf="page != null">

  <button class="link" (click)="prev()" [disabled]="!(page.pageable.pageNumber > 0)">vorige</button>
  <button class="link" (click)="next()" [disabled]="!(page.pageable.pageNumber < page.totalPages-1)">volgende</button>
  <select [(ngModel)]="pageable.page" (ngModelChange)="updatePage()">
    <option *ngFor="let i of getPages()" [value]="i">{{i}}</option>
  </select>
  <input
    type="text" [(ngModel)]="dateSearch"
    placeholder="YYYY-MM-DD"
    (ngModelChange)="dateSearchChange()"
    style="border-style: solid; padding: 5px; margin-left: 5px">
  <div class="spacer"></div>

  <div *ngFor="let statement of page.content let index = index">

    <div class="gray-bg">
      <span class="date">{{iso(statement.openingBalanceDate)}}</span>
      <span class="balance">{{euro(statement.calculatedOpeningBalance)}}</span>
      <span>({{statement.id}})</span>
    </div>
    <div *ngFor="let transaction of statement.transactions">
      <span class="date">{{iso(transaction.valueDate)}}</span>
      <span class="balance">{{euro(transaction.calculatedAmount)}}</span>
      <span>({{transaction.id}})</span>
      {{transaction.transactionDescription}} ({{transaction.createdAt}})
    </div>

    <div class="error mono-space" *ngIf="mismatchedFMinusC(statement)">
      <div class="spacer-small"></div>
      <span *ngFor="let transaction of statement.transactions let index2 = index" class="mono-space">
        <ng-container *ngIf="index2 != 0">+</ng-container>
        {{euro(transaction.calculatedAmount)}}
      </span>
      = {{euro(sum(statement.transactions))}} != {{euro(roundNum(statement.calculatedClosingBalance-statement.calculatedOpeningBalance))}}
    </div>

    <!--
    fixme disconnected liever op opening zodat er niet ineens een extra rij bij zit
    -->
    <div class="error b" *ngIf="index < page.content.length-1 && isDisconnected(statement, page.content[index+1])">
      <span class="date">{{iso(statement.closingBalanceDate)}}</span>
      <span class="balance">{{euro(statement.calculatedClosingBalance)}}</span>
    </div>

    <div class="spacer-small"></div>
  </div>

</div>
